"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chroma_js_1 = __importDefault(require("chroma-js"));
var THEME_BASE_1 = require("../../THEME_BASE");
var globalColors = function (colorScheme, baseBrandColors, baseGlobalColors) { return (__assign(__assign({}, baseGlobalColors), { linkHover: (0, chroma_js_1.default)(baseGlobalColors.link)[colorScheme === THEME_BASE_1.COLOR_SCHEME_DARK ? 'brighten' : 'darken'](1).hex(), navigationBackground: baseGlobalColors.contentBackground, textAlt: baseBrandColors.secondary, textDefault: baseBrandColors.tertiary })); };
exports.default = globalColors;
